export const isFunction = fn => typeof fn === "function";

export const isString = value => typeof value === "string" || value instanceof String;

export const isArray = value => Array.isArray(value);
